<template>
  <div class="section-body">
    <FormSectionTitle
      :cn-name="showHomeConfigMap[showHomeConfig]"
      tooltip="页面配置"
    />
    <!-- 页面配置 -->
    <div v-show="showHomeConfig == 'background'">
      <div class="config_item">
        <FormTitle title="页面名称" />
        <el-input v-model="homeConfig.title" />
      </div>
      <div class="config_item">
        <FormTitle title="背景色" />
        <BackgroundColor
          v-model="homeConfig.backgroundColor"
          :is-quote="true"
          quote-key="backgroundColor"
        />
      </div>
      <FormTitle title="背景图片" />
      <div
        class="config_item"
        :style="{ 'border-bottom': 'none' }"
      >
        <BackgroundImg
          v-model="homeConfig.backgroundImg"
          :is-quote="true"
          quote-key="backgroundImg"
          :layout-type="2"
          :layout-options="pageBackgroundImgLayoutOptions"
        />
      </div>
    </div>
    <!-- 表单通用配置 -->
    <div v-show="showHomeConfig == 'subButton'">
      <div class="config_item">
        <FormTitle title="表单背景色" />
        <BackgroundColor
          v-model="formPageConfig.backgroundColor"
          :is-quote="true"
          quote-key="backgroundColor"
        />
      </div>
      <FormTitle title="表单背景图" />
      <div
        class="config_item"
        :style="{ 'border-bottom': 'none' }"
      >
        <BackgroundImg
          v-model="formPageConfig.backgroundImg"
          :is-quote="true"
          quote-key="backgroundImg"
          :layout-type="2"
          :layout-options="formBackgroundImgLayoutOptions"
        />
      </div>
      <div class="config_item">
        <FormTitle title="表单外边距" />
        <Margin
          key="formPageConfig.margin"
          v-model="formPageConfig.margin"
          quote-key="margin"
          :is-quote="true"
        />
      </div>
      <div class="config_item">
        <FormTitle title="表单内边距" />
        <Margin
          key="formPageConfig.padding"
          v-model="formPageConfig.padding"
          quote-key="margin"
          :is-quote="true"
        />
      </div>
      <div class="config_item">
        <FormTitle title="表单按钮文案" />
        <el-input v-model="subButtonConfig.title" />
      </div>
      <div class="config_item">
        <FontWeight
          v-model="subButtonConfig.fontWeight"
          quote-key="fontWeight"
          :is-quote="true"
        />
      </div>
      <div class="config_item">
        <FormTitle title="按钮字体颜色" />
        <Color
          v-model="subButtonConfig.color"
          quote-key="color"
          :is-quote="true"
        />
      </div>
      <div class="config_item">
        <FormTitle title="按钮背景色" />
        <BackgroundColor
          v-model="subButtonConfig.backgroundColor"
          :is-quote="true"
          quote-key="backgroundColor"
        />
      </div>
      <div class="config_item">
        <FormTitle title="圆角度数（单位:px)" />
        <!-- <el-input v-model="subButtonConfig.borderRadius" /> -->
        <BorderRadius
          v-model="subButtonConfig.borderRadius"
          :is-quote="true"
          quote-key="borderRadius"
        />
      </div>
    </div>
    <!-- 表单项通用配置 -->
    <div v-show="showHomeConfig == 'formMargin'">
      <div class="config_item">
        <FormTitle title="表单项外边距" />
        <Margin
          key="formItemConfig.margin"
          v-model="formItemConfig.margin"
          quote-key="margin"
          :quote-type="[0, '/', 0, '/']"
          :is-quote="true"
        />
      </div>
      <div class="config_item">
        <FormTitle title="表单项名称字体大小" />
        <el-input v-model="formItemConfig.fontSize" />
      </div>
      <div class="config_item">
        <FontWeight
          v-model="formItemConfig.itemFontWeight"
          quote-key="fontWeight"
          :is-quote="true"
        />
      </div>
      <div class="config_item">
        <FormTitle title="控件名称颜色" />
        <Color
          v-model="formItemConfig.color"
          quote-key="color"
          :is-quote="true"
        />
      </div>
      <div class="config_item">
        <FormTitle title="表单项名称到表单控间距" />
        <el-input v-model="formItemConfig.itemTitleToCmpDistance" />
      </div>
      <div class="config_item">
        <FormTitle title="输入框控件样式" />
        <el-radio-group
          v-model="formItemConfig.itemLayout"
          size="small"
          @change="itemLayoutChange"
        >
          <el-radio-button label="box">
            线框
          </el-radio-button>
          <el-radio-button label="gackground">
            底色
          </el-radio-button>
          <el-radio-button label="bottomLine">
            下划线
          </el-radio-button>
        </el-radio-group>
      </div>
      <div
        v-if="formItemConfig.itemLayout == 'box'"
        class="config_item"
      >
        <FormTitle title="输入框控件线框颜色" />
        <Color
          key="box"
          v-model="formItemConfig.inputItemBorderColor"
          quote-key="color"
          :is-quote="true"
        />
      </div>
      <div
        v-if="formItemConfig.itemLayout == 'bottomLine'"
        class="config_item"
      >
        <FormTitle title="输入框控件线框颜色" />
        <Color
          key="itemBottomLineColor"
          v-model="formItemConfig.inputItemBottomLineColor"
          quote-key="color"
          :is-quote="true"
        />
      </div>
      <div
        v-if="formItemConfig.itemLayout == 'gackground'"
        class="config_item"
      >
        <FormTitle title="输入框控件底色" />
        <Color
          key="gackground"
          v-model="formItemConfig.inputBackgroundColor"
          quote-key="color"
          :is-quote="true"
        />
      </div>
    </div>
    <!-- 表单协议 -->
    <div v-show="showHomeConfig == 'formProtocol'">
      <div class="config_item">
        <FormTitle title="协议开关" />
        <el-switch v-model="formProtocolConfig.switch" />
      </div>
      <div class="config_item">
        <FormTitle title="协议名称" />
        <el-input v-model="formProtocolConfig.title" />
      </div>
      <div class="config_item">
        <FormTitle title="协议内容" />
        <el-input
          v-model="formProtocolConfig.context"
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 10 }"
          placeholder="请输入内容"
        />
      </div>
    </div>
  </div>
</template>
<script>
import FormSectionTitle from '@/view/weappTmp/comps/sectionTitle/index.vue'
import BackgroundColor from '@/weappTmps/comps/backgroundColor/index.vue'
import BackgroundImg from '@/weappTmps/comps/backgroundImg/index.vue'
import FormTitle from '@/view/weappTmp/comps/title/index.vue'
import tmpStore from '@/view/weappTmp/core/lib/base/store.js'
import Color from '@/weappTmps/comps/color/index.vue'
import Margin from '@/weappTmps/comps/margin/index.vue'
import FontWeight from '@/weappTmps/comps/fontWeight/index.vue'
import BorderRadius from '@/weappTmps/comps/borderRadius/index.vue'
// import Margin from '@/weappTmps/comps/margin/index.vue'
// import Margin from '@/weappTmps/comps/margin/index.vue'
const showHomeConfigMap = {
  'background': '页面配置',
  'subButton': '表单通用配置',
  'formMargin': '表单项通用配置'
  // 'formProtocol': '表单协议'
}
const pageBackgroundImgLayoutOptions = [
  {
    label: '顶部',
    value: 'top'
  },
  {
    label: '底部',
    value: 'bottom'
  }
]

const formBackgroundImgLayoutOptions = [
  {
    label: '全覆盖',
    value: 'all'
  },
  {
    label: '高度自适应',
    value: 'autoHeight'
  }
]
export default {
  name: 'HomeProps',
  components: {
    FormSectionTitle,
    FormTitle,
    BackgroundColor,
    BackgroundImg,
    Color,
    Margin,
    FontWeight,
    BorderRadius
  },
  props: {
    showHomeConfig: {
      type: String
    }
  },
  data () {
    return {
      pageBackgroundImgLayoutOptions,
      formBackgroundImgLayoutOptions,
      showHomeConfigMap: showHomeConfigMap,
      homeConfig: {
        title: '',
        backgroundColor: '',
        backgroundImg: {
          showType: 'full-width',
          url: ''
        },
        margin: []
      },
      subButtonConfig: {
        backgroundColor: '',
        color: '',
        title: '提交按钮',
        fontWeight: '1',
        borderRadius: '0'
      },
      formProtocolConfig: {
        switch: false,
        title: '',
        context: ''
      },
      formItemConfig: {
        margin: [],
        itemPadding: '',
        fontSize: '12',
        itemFontWeight: '1',
        color: '',
        itemTitleToCmpDistance: '', //表单项名称到表单控间距
        itemLayout: '',
        itemBorderColor: '',
        itemBottomLineColor: '',
        backgroundColor: '',
        inputItemBorderColor: '',
        inputItemBottomLineColor: '',
        inputBackgroundColor: ''
      },
      formPageConfig: {
        margin: [],
        padding: [],
        backgroundColor: '',
        backgroundImg: {
          showType: null,
          url: ''
        }
      }
    }
  },
  watch: {
    homeConfig: {
      handler (nv) {
        console.log('homeConfig', nv)
        this.updateHomeView()
      },
      deep: true
    },
    subButtonConfig: {
      handler (nv) {
        console.log('watch:subButtonConfig', nv)
        this.updateHomeView()
      },
      deep: true
    },
    formProtocolConfig: {
      handler (nv) {
        console.log('formProtocolConfig', nv)
        this.updateHomeView()
      },
      deep: true
    },
    formPageConfig: {
      handler (nv) {
        console.log('formPageConfig', nv)
        this.updateHomeView()
      },
      deep: true
    },
    formItemConfig: {
      handler (nv) {
        console.log('formItemConfig', nv)
        this.updateHomeView()
      },
      deep: true
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      const homeConfigs = tmpStore.getVal('homeConfig') || {}
      const { homeConfig, formProtocolConfig, subButtonConfig, formPageConfig, formItemConfig } =
        homeConfigs
      console.log('methods:init-formPageConfig', formPageConfig)
      this.homeConfig = homeConfig || this.homeConfig
      this.formProtocolConfig = formProtocolConfig || this.formProtocolConfig
      this.subButtonConfig = subButtonConfig || this.subButtonConfig
      this.formPageConfig = formPageConfig || this.formPageConfig
      this.formItemConfig = formItemConfig || this.formItemConfig
    },
    onSubmit () {
      console.log('submit!')
    },
    selectImageData (selectdata) {
      let msg_type = 'image'
      if (msg_type === 'image') {
        this.homeConfig.url = selectdata
      } else if (msg_type === 'link') {
        this.content.link.picurl = selectdata
      } else if (msg_type === 'miniprogram') {
        this.content.miniprogram.img_url = selectdata
      }
    },
    updateHomeView () {
      const { homeConfig, subButtonConfig, formProtocolConfig, formPageConfig, formItemConfig } =
        this
      const data = {
        homeConfig,
        subButtonConfig,
        formProtocolConfig,
        formPageConfig,
        formItemConfig
      }
      console.log('updateHomeView', data)
      tmpStore.setVal('homeConfig', data)
    },
    itemLayoutChange () {
      const Layout = this.formItemConfig.itemLayout
      if (Layout == 'box') {
        this.$set(this.formItemConfig, 'inputBackgroundColor', '')
        this.$set(this.formItemConfig, 'inputItemBottomLineColor', '')
      }
      if (Layout == 'gackground') {
        this.$set(this.formItemConfig, 'inputItemBorderColor', '')
        this.$set(this.formItemConfig, 'inputItemBottomLineColor', '')
      }
      if (Layout == 'bottomLine') {
        this.$set(this.formItemConfig, 'inputBackgroundColor', '')
        this.$set(this.formItemConfig, 'inputItemBorderColor', '')
      }
    }
  }
}
</script>

<style scoped lang="scss">
.form_title {
  margin-bottom: 14px;
  &_text {
    margin-right: 5px;
    height: 22px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
  }
}
</style>
